import { Scope } from '@/domain/external-invitation/entities/external-invitation.entity';

import { SCOPE_URLS } from './scope-urls';

export function getScopeUrlFromScope(scope: Scope): string {
  return `${import.meta.env.VITE_BASE_URL}/${SCOPE_URLS[scope]}`;
}
